<template>
  <div class="consulta-venta-container">
    <!-- Loading Overlay -->
    <div v-if="isLoading" class="loading-overlay">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Cargando...</span>
      </div>
    </div>

    <!-- Page Header 
    <div class="page-header mb-4">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Consulta de Ventas</h3>
          <p class="text-muted mb-0">Consulta y análisis de ventas por diferentes períodos</p>
        </div>
        <div class="col-auto">
          <button class="btn btn-primary" @click="exportarVentas">
            <i class="fas fa-download me-2"></i>
            Exportar
          </button>
        </div>
      </div>
    </div>-->

    <!-- Filtros Section -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <div class="row align-center">
              <div class="col">
                <h5 class="card-title"><i class="fas fa-filter me-2"></i>Venta</h5>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row g-3">
              <!-- Tipo de Período -->
              <div class="col-md-3">
                <label class="form-label">Tipo de Período</label>
                <select v-model="filtros.tipoPeriodo" class="form-select" @change="onTipoPeriodoChange">
                  <option value="dia">Día</option>
                  <option value="semana">Semana</option>
                  <option value="mes">Mes</option>
                  <option value="anio">Año</option>
                  <option value="rango">Rango Personalizado</option>
                </select>
              </div>

              <!-- Fecha Específica (para día) -->
              <div class="col-md-3" v-if="filtros.tipoPeriodo === 'dia'">
                <label class="form-label">Fecha</label>
                <input type="date" v-model="filtros.fechaEspecifica" class="form-control">
              </div>

              <!-- Semana -->
              <div class="col-md-3" v-if="filtros.tipoPeriodo === 'semana'">
                <label class="form-label">Semana</label>
                <input type="week" v-model="filtros.semana" class="form-control">
              </div>

              <!-- Mes y Año -->
              <div class="col-md-3" v-if="filtros.tipoPeriodo === 'mes'">
                <label class="form-label">Mes</label>
                <select v-model="filtros.mes" class="form-select">
                  <option value="1">Enero</option>
                  <option value="2">Febrero</option>
                  <option value="3">Marzo</option>
                  <option value="4">Abril</option>
                  <option value="5">Mayo</option>
                  <option value="6">Junio</option>
                  <option value="7">Julio</option>
                  <option value="8">Agosto</option>
                  <option value="9">Septiembre</option>
                  <option value="10">Octubre</option>
                  <option value="11">Noviembre</option>
                  <option value="12">Diciembre</option>
                </select>
              </div>

              <div class="col-md-2" v-if="filtros.tipoPeriodo === 'mes'">
                <label class="form-label">Año</label>
                <input type="number" v-model="filtros.anioMes" class="form-control" min="2020" :max="currentYear">
              </div>

              <!-- Año -->
              <div class="col-md-3" v-if="filtros.tipoPeriodo === 'anio'">
                <label class="form-label">Año</label>
                <input type="number" v-model="filtros.anio" class="form-control" min="2020" :max="currentYear">
              </div>

              <!-- Rango Personalizado -->
              <div class="col-md-3" v-if="filtros.tipoPeriodo === 'rango'">
                <label class="form-label">Fecha Inicio</label>
                <input type="date" v-model="filtros.fechaInicio" class="form-control">
              </div>

              <div class="col-md-3" v-if="filtros.tipoPeriodo === 'rango'">
                <label class="form-label">Fecha Fin</label>
                <input type="date" v-model="filtros.fechaFin" class="form-control">
              </div>

              <!-- Estado de Venta -->
              <div class="col-md-3">
                <label class="form-label">Estado</label>
                <select v-model="filtros.estado" class="form-select">
                  <option value="">Todos</option>
                  <option value="Pendiente">Pendiente</option>
                  <option value="En Proceso">En Proceso</option>
                  <option value="Entregado">Entregado</option>
                  <option value="Anulada">Anulada</option>
                </select>
              </div>

              <!-- Método de Pago -->
              <div class="col-md-3">
                <label class="form-label">Método de Pago</label>
                <select v-model="filtros.metodoPago" class="form-select">
                  <option value="">Todos</option>
                  <option value="Efectivo">Efectivo</option>
                  <option value="tarjeta">Tarjeta</option>
                  <option value="transferencia">Transferencia</option>
                  <option value="pago_movil">Pago Móvil</option>
                </select>
              </div>

              <!-- Botón Buscar -->
              <div class="col-12">
                <button class="btn btn-primary me-2" @click="buscarVentas">
                  <i class="fas fa-search me-2"></i>
                  Buscar
                </button>
                <button class="btn btn-secondary" @click="limpiarFiltros">
                  <i class="fas fa-eraser me-2"></i>
                  Limpiar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Estadísticas -->
    <div class="row mb-4">
      <div class="col-md-3">
        <div class="card stat-card">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h6 class="text-muted mb-2">Total Ventas</h6>
                <h3 class="mb-0">{{ estadisticas.totalVentas }}</h3>
              </div>
              <div class="stat-icon bg-primary">
                <i class="fas fa-shopping-cart"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-3">
        <div class="card stat-card">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h6 class="text-muted mb-2">Monto Total</h6>
                <h3 class="mb-0">{{ formatoMoneda(estadisticas.montoTotal) }}</h3>
              </div>
              <div class="stat-icon bg-success">
                <i class="fas fa-dollar-sign"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-3">
        <div class="card stat-card">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h6 class="text-muted mb-2">Promedio</h6>
                <h3 class="mb-0">{{ formatoMoneda(estadisticas.promedioVenta) }}</h3>
              </div>
              <div class="stat-icon bg-info">
                <i class="fas fa-chart-line"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-3">
        <div class="card stat-card">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h6 class="text-muted mb-2">Productos Vendidos</h6>
                <h3 class="mb-0">{{ estadisticas.totalProductos }}</h3>
              </div>
              <div class="stat-icon bg-warning">
                <i class="fas fa-box"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tabla de Ventas -->
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <div class="row align-center">
              <div class="col">
                <h5 class="card-title"><i class="fas fa-list me-2"></i>Listado de Ventas</h5>
              </div>
              <div class="col-auto">
                <div class="d-flex align-items-center">
                  <label class="me-2 mb-0">Mostrar:</label>
                  <select v-model="paginacion.porPagina" class="form-select form-select-sm" style="width: auto;" @change="cambiarPorPagina">
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body p-0">
            <div class="table-responsive">
              <table class="table table-hover table-striped mb-0">
                <thead class="table-light">
                  <tr>
                    <th>N° Venta</th>
                    <th>Fecha</th>
                    <th>Cliente</th>
                    <th>Productos</th>
                    <th>Método Pago</th>
                    <th class="text-end">Total</th>
                    <th class="text-end">Total Pagado (Bs)</th>
                    <th>Estado</th>
                    <th class="text-center">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="ventas.length === 0">
                    <td colspan="9" class="text-center py-4">
                      <i class="fas fa-inbox fa-3x text-muted mb-3 d-block"></i>
                      <p class="text-muted mb-0">No se encontraron ventas con los filtros seleccionados</p>
                    </td>
                  </tr>
                  <tr v-for="(venta, index) in ventasPaginadas" :key="venta.id">
                    <td><span class="badge bg-primary">{{ venta.nventa }}</span></td>
                    <td>
                      <div>{{ formatearFecha(venta.fecha) }}</div>
                      <small class="text-muted">{{ formatearHora(venta.fecha) }}</small>
                    </td>
                    <td>
                      <div class="fw-semibold">{{ venta.cliente }}</div>
                      <small class="text-muted">{{ venta.documento }}</small>
                    </td>
                    <td>
                      <span class="badge bg-light text-dark">{{ venta.detalles.length }} items</span>
                      <!--<span class="badge bg-light text-dark">{{ venta.cantidadProductos }} items</span>-->
                    </td>
                    <td>
                      <span class="badge" :class="getMetodoPagoBadge(venta.metodoPago)">
                        {{ venta.metodoPago }}
                      </span>
                    </td>
                    <td class="text-end fw-semibold">{{ formatoMoneda(venta.total) }}</td>
                    <td class="text-end fw-semibold">{{ formatoMonedaBs(venta.total_pagado) }}</td>
                    <td>
                      <span class="badge" :class="getEstadoBadge(venta.estado)">
                        {{ venta.estado }}
                      </span>
                    </td>
                    <td class="text-center">
                      <div class="btn-group btn-group-sm" role="group">
                        <button
                          class="btn btn-outline-primary"
                          @click="verDetalle(venta)"
                          data-bs-toggle="modal"
                          data-bs-target="#modalDetalleVenta"
                          title="Ver Detalle">
                          <i class="fas fa-eye"></i>
                        </button>
                        <button class="btn btn-outline-secondary" @click="imprimirVenta(venta)" title="Imprimir">
                          <i class="fas fa-print"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Paginación -->
          <div class="card-footer" v-if="ventas.length > 0">
            <div class="row align-items-center">
              <div class="col">
                <p class="mb-0 text-muted">
                  Mostrando {{ rangoInicio }} a {{ rangoFin }} de {{ ventas.length }} ventas
                </p>
              </div>
              <div class="col-auto">
                <nav>
                  <ul class="pagination pagination-sm mb-0">
                    <li class="page-item" :class="{ disabled: paginacion.paginaActual === 1 }">
                      <a class="page-link" href="#" @click.prevent="cambiarPagina(paginacion.paginaActual - 1)">
                        <i class="fas fa-chevron-left"></i>
                      </a>
                    </li>
                    <li
                      class="page-item"
                      v-for="pagina in paginasVisibles"
                      :key="pagina"
                      :class="{ active: pagina === paginacion.paginaActual }"
                    >
                      <a class="page-link" href="#" @click.prevent="cambiarPagina(pagina)">
                        {{ pagina }}
                      </a>
                    </li>
                    <li class="page-item" :class="{ disabled: paginacion.paginaActual === totalPaginas }">
                      <a class="page-link" href="#" @click.prevent="cambiarPagina(paginacion.paginaActual + 1)">
                        <i class="fas fa-chevron-right"></i>
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Detalle de Venta -->
    <div class="modal fade" id="modalDetalleVenta" tabindex="-1" aria-labelledby="modalDetalleVentaLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalDetalleVentaLabel">
              <i class="fas fa-receipt me-2"></i>
              Detalle de Venta {{ ventaSeleccionada?.nventa }}
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body" v-if="ventaSeleccionada">
            <!-- Información General -->
            <div class="row mb-4">
              <div class="col-md-6">
                <h6 class="text-muted mb-3">Información de la Venta</h6>
                <p class="mb-2"><strong>N° Venta:</strong> <span class="badge bg-primary">{{ ventaSeleccionada.nventa }}</span></p>
                <p class="mb-2"><strong>Fecha:</strong> {{ formatearFecha(ventaSeleccionada.createdAt) }} {{ formatearHora(ventaSeleccionada.createdAt) }}</p>
                <p class="mb-2"><strong>Estado:</strong> <span class="badge" :class="getEstadoBadge(ventaSeleccionada.estado)">{{ ventaSeleccionada.estado }}</span></p>
                <p class="mb-2"><strong>Método de Pago:</strong> <span class="badge" :class="getMetodoPagoBadge(ventaSeleccionada.forma_pago)">{{ ventaSeleccionada.forma_pago }}</span></p>
                <p class="mb-2" v-if="ventaSeleccionada.transaccion"><strong>N° Transacción:</strong> {{ ventaSeleccionada.transaccion }}</p>
                <p class="mb-2" v-if="ventaSeleccionada.bancoId"><strong>Banco:</strong> {{ ventaSeleccionada.banco.nombre }}</p>
              </div>
              <div class="col-md-6">
                <h6 class="text-muted mb-3">Información del Cliente</h6>
                <p class="mb-2"><strong>Nombre:</strong> {{ ventaSeleccionada.cliente?.nombres }} {{ ventaSeleccionada.cliente?.apellidos }}</p>
                <p class="mb-2"><strong>Email:</strong> {{ ventaSeleccionada.cliente?.email }}</p>
                <p class="mb-2" v-if="ventaSeleccionada.cliente?.genero"><strong>Género:</strong> {{ ventaSeleccionada.cliente.genero }}</p>
                <p class="mb-2" v-if="ventaSeleccionada.cliente?.pais"><strong>País:</strong> {{ ventaSeleccionada.cliente.pais }}</p>
              </div>
            </div>

            <!-- Información de Dirección de Envío -->
            <div class="row mb-4" v-if="ventaSeleccionada.direccion">
              <div class="col-12">
                <h6 class="text-muted mb-3">Dirección de Envío</h6>
                <div class="card bg-light">
                  <div class="card-body">
                    <p class="mb-2"><strong>Dirección:</strong> {{ ventaSeleccionada.direccion.direccion }}</p>
                    <p class="mb-2"><strong>Teléfono:</strong> {{ ventaSeleccionada.direccion.telefono }}</p>
                    <div class="row">
                      <div class="col-md-4">
                        <p class="mb-2"><strong>Ciudad:</strong> {{ ventaSeleccionada.direccion.ciudad }}</p>
                      </div>
                      <div class="col-md-4">
                        <p class="mb-2"><strong>País:</strong> {{ ventaSeleccionada.direccion.pais }}</p>
                      </div>
                      <div class="col-md-4">
                        <p class="mb-2"><strong>Código Postal:</strong> {{ ventaSeleccionada.direccion.zip }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Productos -->
            <h6 class="text-muted mb-3">Productos</h6>
            <div class="table-responsive mb-4">
              <table class="table table-sm table-bordered">
                <thead class="table-light">
                  <tr>
                    <th>Producto</th>
                    <th>SKU</th>
                    <th>Variedad</th>
                    <th class="text-center">Cantidad</th>
                    <th class="text-end">Precio Unit.</th>
                    <th class="text-end">Subtotal</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="detalle in ventaSeleccionada.detalles" :key="detalle.id">
                    <td>
                      <div class="fw-semibold">{{ detalle.producto?.titulo || `Producto #${detalle.productoId}` }}</div>
                      <small class="text-muted">{{ detalle.producto?.slug }}</small>
                    </td>
                    <td>
                      <span v-if="detalle.variedad?.sku" class="badge bg-secondary">{{ detalle.variedad.sku }}</span>
                      <span v-else class="text-muted">-</span>
                    </td>
                    <td>
                      <div v-if="detalle.variedad">
                        <span v-if="detalle.variedad.talla" class="badge bg-info me-1">{{ detalle.variedad.talla }}</span>
                        <span v-if="detalle.variedad.color" class="badge bg-success me-1">{{ detalle.variedad.color }}</span>
                        <span v-if="detalle.variedad.medida" class="badge bg-warning">{{ detalle.variedad.medida }}</span>
                      </div>
                      <span v-else class="text-muted">Sin variedad</span>
                    </td>
                    <td class="text-center">{{ detalle.cantidad }}</td>
                    <td class="text-end">{{ formatoMoneda(detalle.precio_unidad) }}</td>
                    <td class="text-end fw-semibold">{{ formatoMoneda(detalle.cantidad * detalle.precio_unidad) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Totales -->
            <div class="row">
              <div class="col-md-6 offset-md-6">
                <table class="table table-sm">
                  <tr>
                    <td class="text-end"><strong>Subtotal:</strong></td>
                    <td class="text-end">{{ formatoMoneda(ventaSeleccionada.subtotal) }}</td>
                  </tr>
                  <tr>
                    <td class="text-end"><strong>Envío:</strong></td>
                    <td class="text-end">{{ formatoMoneda(ventaSeleccionada.envio) }}</td>
                  </tr>
                  <tr class="table-primary">
                    <td class="text-end"><strong>Total:</strong></td>
                    <td class="text-end"><strong>{{ formatoMoneda(ventaSeleccionada.total) }}</strong></td>
                  </tr>
                  <tr class="table-success">
                    <td class="text-end"><strong>Total Pagado (Bs):</strong></td>
                    <td class="text-end"><strong>{{ formatoMonedaBs(ventaSeleccionada.total_pagado) }}</strong></td>
                  </tr>
                </table>
              </div>
            </div>

            <!-- Cambiar Estado -->
            <div class="row mt-4" v-if="ventaSeleccionada.estado !== 'Entregado' && ventaSeleccionada.estado !== 'Procesado'">
              <div class="col-12">
                <h6 class="text-muted mb-3">Cambiar Estado</h6>
                <div class="d-flex gap-2">
                  <button
                    v-if="ventaSeleccionada.estado === 'Pendiente'"
                    class="btn btn-warning"
                    @click="cambiarEstado('En Proceso')"
                    :disabled="isLoading">
                    <i class="fas fa-clock me-2"></i>
                    Marcar como En Proceso
                  </button>
                  <button
                    v-if="ventaSeleccionada.estado === 'En Proceso' || ventaSeleccionada.estado === 'Pendiente'"
                    class="btn btn-success"
                    @click="cambiarEstado('Entregado')"
                    :disabled="isLoading">
                    <i class="fas fa-truck me-2"></i>
                    Marcar como Entregado
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary m-1" data-bs-dismiss="modal">Cerrar</button>
            <button type="button" class="btn btn-primary m-1" @click="imprimirVenta(ventaSeleccionada)">
              <i class="fas fa-print me-2"></i>
              Imprimir
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';

export default {
  name: 'ConsultaVenta',
  data() {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;

    return {
      isLoading: false,
      currentYear,
      filtros: {
        tipoPeriodo: 'dia',
        fechaEspecifica: currentDate.toISOString().split('T')[0],
        semana: '',
        mes: currentMonth.toString(),
        anioMes: currentYear,
        anio: currentYear,
        fechaInicio: '',
        fechaFin: '',
        estado: '',
        metodoPago: ''
      },
      ventas: [],
      ventaSeleccionada: null,
      estadisticas: {
        totalVentas: 0,
        montoTotal: 0,
        promedioVenta: 0,
        totalProductos: 0
      },
      paginacion: {
        paginaActual: 1,
        porPagina: 25
      }
    };
  },
  computed: {
    ventasPaginadas() {
      const inicio = (this.paginacion.paginaActual - 1) * this.paginacion.porPagina;
      const fin = inicio + parseInt(this.paginacion.porPagina);
      return this.ventas.slice(inicio, fin);
    },
    totalPaginas() {
      return Math.ceil(this.ventas.length / this.paginacion.porPagina);
    },
    paginasVisibles() {
      const total = this.totalPaginas;
      const actual = this.paginacion.paginaActual;
      const paginas = [];

      if (total <= 7) {
        for (let i = 1; i <= total; i++) {
          paginas.push(i);
        }
      } else {
        if (actual <= 4) {
          for (let i = 1; i <= 5; i++) paginas.push(i);
          paginas.push('...');
          paginas.push(total);
        } else if (actual >= total - 3) {
          paginas.push(1);
          paginas.push('...');
          for (let i = total - 4; i <= total; i++) paginas.push(i);
        } else {
          paginas.push(1);
          paginas.push('...');
          for (let i = actual - 1; i <= actual + 1; i++) paginas.push(i);
          paginas.push('...');
          paginas.push(total);
        }
      }

      return paginas.filter(p => p !== '...' || paginas.indexOf(p) === paginas.lastIndexOf(p));
    },
    rangoInicio() {
      return (this.paginacion.paginaActual - 1) * this.paginacion.porPagina + 1;
    },
    rangoFin() {
      const fin = this.paginacion.paginaActual * this.paginacion.porPagina;
      return fin > this.ventas.length ? this.ventas.length : fin;
    }
  },
  mounted() {
    this.cargarVentasIniciales();
  },
  methods: {
    async cargarVentasIniciales() {
      // Cargar ventas del día actual al iniciar
      await this.buscarVentas();
    },

    prepararParametros() {
      const params = {
        tipoPeriodo: this.filtros.tipoPeriodo
      };

      // Agregar parámetros específicos según el tipo de período
      switch (this.filtros.tipoPeriodo) {
        case 'dia':
          if (this.filtros.fechaEspecifica) {
            params.fechaEspecifica = this.filtros.fechaEspecifica;
          }
          break;

        case 'semana':
          if (this.filtros.semana) {
            params.semana = this.filtros.semana;
          }
          break;

        case 'mes':
          if (this.filtros.mes && this.filtros.anioMes) {
            params.mes = parseInt(this.filtros.mes);
            params.anioMes = parseInt(this.filtros.anioMes);
          }
          break;

        case 'anio':
          if (this.filtros.anio) {
            params.anio = parseInt(this.filtros.anio);
          }
          break;

        case 'rango':
          if (this.filtros.fechaInicio && this.filtros.fechaFin) {
            params.fechaInicio = this.filtros.fechaInicio;
            params.fechaFin = this.filtros.fechaFin;
          }
          break;
      }

      // Agregar filtros opcionales
      if (this.filtros.estado) {
        params.estado = this.filtros.estado;
      }

      if (this.filtros.metodoPago) {
        params.metodoPago = this.filtros.metodoPago;
      }

      return params;
    },

    calcularEstadisticas() {
      this.estadisticas.totalVentas = this.ventas.length;
      this.estadisticas.montoTotal = this.ventas.reduce((sum, venta) => sum + venta.total, 0);
      this.estadisticas.promedioVenta = this.estadisticas.totalVentas > 0
        ? this.estadisticas.montoTotal / this.estadisticas.totalVentas
        : 0;
      this.estadisticas.totalProductos = this.ventas.reduce((sum, venta) => sum + venta.cantidadProductos, 0);
    },

    async buscarVentas() {
      this.isLoading = true;

      try {
        const params = this.prepararParametros();

        // Validar que haya al menos un parámetro de filtro
        if (Object.keys(params).length === 0) {
          this.$toast.warning('Por favor seleccione un período válido');
          this.isLoading = false;
          return;
        }


        const response = await api.get('/venta/report', { params });

        // Verificar si la respuesta fue exitosa
        if (!response.data || !response.data.ok) {
          throw new Error('Error en la respuesta del servidor');
        }

        // Usar estadísticas del backend
        if (response.data.estadisticas) {
          this.estadisticas = {
            totalVentas: response.data.estadisticas.totalVentas || 0,
            montoTotal: response.data.estadisticas.montoTotal || 0,
            promedioVenta: response.data.estadisticas.promedioVenta || 0,
            totalProductos: response.data.estadisticas.totalProductos || 0
          };
        }

        // Mapear la respuesta del API al formato de la tabla
        this.ventas = (response.data.ventas || []).map(venta => {
          // Calcular cantidad total de productos de los detalles
          const cantidadProductos = venta.detalles
            ? venta.detalles.reduce((sum, detalle) => sum + (detalle.cantidad || 0), 0)
            : 0;

          // Construir nombre completo del cliente
          const nombreCliente = venta.cliente
            ? `${venta.cliente.nombres || ''} ${venta.cliente.apellidos || ''}`.trim()
            : 'Cliente General';

          return {
            id: venta.id,
            nventa: venta.nventa,
            fecha: venta.createdAt,
            cliente: nombreCliente,
            clienteCompleto: venta.cliente,
            documento: venta.cliente?.email || '-',
            cantidadProductos: cantidadProductos,
            metodoPago: venta.forma_pago || 'efectivo',
            total: parseFloat(venta.total || 0),
            subtotal: parseFloat(venta.subtotal || 0),
            envio: parseFloat(venta.envio || 0),
            total_pagado: parseFloat(venta.total_pagado || 0),
            estado: venta.estado || 'Pendiente',
            detalles: venta.detalles || [],
            transaccion: venta.transaccion || '',
            direccionId: venta.direccionId
          };
        });

        this.paginacion.paginaActual = 1;
        this.$toast.success(`Se encontraron ${this.ventas.length} ventas`);
      } catch (error) {
        console.error('Error al buscar ventas:', error);
        this.ventas = [];
        this.estadisticas = {
          totalVentas: 0,
          montoTotal: 0,
          promedioVenta: 0,
          totalProductos: 0
        };

        let errorMessage = 'Error al cargar las ventas';
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        } else if (error.message) {
          errorMessage = error.message;
        }

        this.$toast.error(errorMessage);
      } finally {
        this.isLoading = false;
      }
    },

    limpiarFiltros() {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth() + 1;

      this.filtros = {
        tipoPeriodo: 'dia',
        fechaEspecifica: currentDate.toISOString().split('T')[0],
        semana: '',
        mes: currentMonth.toString(),
        anioMes: currentYear,
        anio: currentYear,
        fechaInicio: '',
        fechaFin: '',
        estado: '',
        metodoPago: ''
      };

      this.buscarVentas();
    },

    onTipoPeriodoChange() {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth() + 1;

      // Limpiar y establecer valores por defecto según el tipo de período
      this.filtros.fechaEspecifica = '';
      this.filtros.semana = '';
      this.filtros.fechaInicio = '';
      this.filtros.fechaFin = '';

      // Establecer valor por defecto según el tipo seleccionado
      switch (this.filtros.tipoPeriodo) {
        case 'dia':
          this.filtros.fechaEspecifica = currentDate.toISOString().split('T')[0];
          break;
        case 'mes':
          this.filtros.mes = currentMonth.toString();
          this.filtros.anioMes = currentYear;
          break;
        case 'anio':
          this.filtros.anio = currentYear;
          break;
      }
    },

    cambiarPagina(pagina) {
      if (pagina >= 1 && pagina <= this.totalPaginas) {
        this.paginacion.paginaActual = pagina;
      }
    },

    cambiarPorPagina() {
      this.paginacion.paginaActual = 1;
    },

    formatoMoneda(value) {
      if (!value) return '$0,00';
      const numero = Number(value).toFixed(2);
      return '$' + numero
        .replace('.', ',')
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },

    formatoMonedaBs(value) {
      if (!value) return 'Bs 0,00';
      const numero = Number(value).toFixed(2);
      return 'Bs ' + numero
        .replace('.', ',')
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },

    formatearFecha(fecha) {
      const date = new Date(fecha);
      const dia = String(date.getDate()).padStart(2, '0');
      const mes = String(date.getMonth() + 1).padStart(2, '0');
      const anio = date.getFullYear();
      return `${dia}/${mes}/${anio}`;
    },

    formatearHora(fecha) {
      const date = new Date(fecha);
      const horas = String(date.getHours()).padStart(2, '0');
      const minutos = String(date.getMinutes()).padStart(2, '0');
      return `${horas}:${minutos}`;
    },

    getEstadoBadge(estado) {
      const estadoLower = (estado || '').toLowerCase();
      const badges = {
        'completada': 'bg-success',
        'completado': 'bg-success',
        'entregado': 'bg-success',
        'procesado': 'bg-success',
        'pendiente': 'bg-warning',
        'en proceso': 'bg-info',
        'anulada': 'bg-danger',
        'anulado': 'bg-danger',
        'cancelada': 'bg-danger',
        'cancelado': 'bg-danger'
      };
      return badges[estadoLower] || 'bg-secondary';
    },

    getMetodoPagoBadge(metodo) {
      const metodoLower = (metodo || '').toLowerCase();
      const badges = {
        'efectivo': 'bg-success',
        'tarjeta': 'bg-primary',
        'transferencia': 'bg-info',
        'transferencia bancaria': 'bg-info',
        'pago_movil': 'bg-warning',
        'pago movil': 'bg-warning',
        'pago móvil': 'bg-warning',
        'punto de venta': 'bg-primary'
      };
      return badges[metodoLower] || 'bg-secondary';
    },

    async verDetalle(venta) {
      this.isLoading = true;
      try {
        const response = await api.get(`/venta/admin/${venta.id}`);

        if (!response.data) {
          throw new Error('Error al obtener los detalles de la venta');
        }

        this.ventaSeleccionada = response.data;
      } catch (error) {
        console.error('Error al cargar detalle de venta:', error);
        let errorMessage = 'Error al cargar los detalles de la venta';
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        } else if (error.message) {
          errorMessage = error.message;
        }
        this.$toast.error(errorMessage);
      } finally {
        this.isLoading = false;
      }
    },

    async cambiarEstado(nuevoEstado) {
      const result = await this.$swal.fire({
        title: '¿Cambiar Estado?',
        text: `¿Está seguro de cambiar el estado a "${nuevoEstado}"?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí, cambiar',
        cancelButtonText: 'Cancelar'
      });

      if (!result.isConfirmed) return;

      this.isLoading = true;

      try {
        await api.get(`/venta/admin/cambiar-estado/${this.ventaSeleccionada.id}/${nuevoEstado}`);

        // Actualizar el estado en la venta seleccionada
        this.ventaSeleccionada.estado = nuevoEstado;

        // Actualizar el estado en la lista de ventas
        const ventaIndex = this.ventas.findIndex(v => v.id === this.ventaSeleccionada.id);
        if (ventaIndex !== -1) {
          this.ventas[ventaIndex].estado = nuevoEstado;
        }

        this.$toast.success(`Estado actualizado a "${nuevoEstado}"`);
      } catch (error) {
        console.error('Error al cambiar estado:', error);
        let errorMessage = 'Error al cambiar el estado';
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        } else if (error.message) {
          errorMessage = error.message;
        }
        this.$toast.error(errorMessage);
      } finally {
        this.isLoading = false;
      }
    },

    imprimirVenta(venta) {
      this.$toast.info(`Imprimir venta #${venta.nventa}`);
      // Aquí irá la lógica para imprimir
    },

    exportarVentas() {
      this.$toast.info('Exportando ventas...');
      // Aquí irá la lógica para exportar a Excel/PDF
    }
  }
};
</script>

<style scoped>
.consulta-venta-container {
  padding: 0;
}

.page-header {
  margin-bottom: 1.5rem;
}

.page-title {
  margin-bottom: 0.25rem;
  font-weight: 600;
}

.stat-card {
  border: none;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s;
}

.stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
}

.stat-icon {
  width: 50px;
  height: 50px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.5rem;
}

.card {
  border: none;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
  margin-bottom: 1.5rem;
}

.card-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  padding: 1rem 1.5rem;
}


.table th {
  font-weight: 600;
  color: #333;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 0.5px;
  border-bottom: 2px solid #dee2e6;
}

.table td {
  vertical-align: middle;
}

.table-hover tbody tr:hover {
  background-color: #f8f9fa;
}

.badge {
  font-weight: 500;
  padding: 0.35em 0.65em;
  text-transform: capitalize;
}

.btn-group-sm .btn {
  padding: 0.25rem 0.5rem;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(2px);
}

.pagination {
  gap: 0.25rem;
}

.page-link {
  border-radius: 0.25rem;
  border: 1px solid #dee2e6;
}

.page-item.active .page-link {
  background-color: #0d6efd;
  border-color: #0d6efd;
}

.form-label {
  font-weight: 500;
  color: #333;
  margin-bottom: 0.5rem;
}

.form-select,
.form-control {
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
}

.form-select:focus,
.form-control:focus {
  border-color: #86b7fe;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

@media (max-width: 768px) {
  .stat-card {
    margin-bottom: 1rem;
  }

  .btn-group {
    flex-direction: column;
  }

  .table-responsive {
    font-size: 0.875rem;
  }
}
</style>
